import { render, staticRenderFns } from "./addkc.vue?vue&type=template&id=0eff8058&scoped=true"
import script from "./addkc.vue?vue&type=script&lang=js"
export * from "./addkc.vue?vue&type=script&lang=js"
import style0 from "./addkc.vue?vue&type=style&index=0&id=0eff8058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff8058",
  null
  
)

export default component.exports